import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AppleCallbackComponent } from './apple-callback.component'
import { GoogleCallbackComponent } from './google-callback.component'
import { AuthGuard } from './guards/auth.guard'
import { FriendProfileGuard } from './guards/friend-profile.guard'
import { KakaoCallbackGuard } from './guards/kakao-callback.guard'
import { KakaoCallbackComponent } from './kakao-callback.component'
import { AlarmComponent } from './pages/alarm/alarm.component'
import { BubbleChartComponent } from './pages/bubble-chart/bubble-chart.component'
import { InstallComponent } from './pages/install/install.component'
import { TermsComponent } from './pages/terms/terms.component'
import { TypesStoryComponent } from './pages/types-story/types-story.component'
import { isCabinetLink } from './services/cabinet/cabinet.service'

const routes: Routes = isCabinetLink
  ? [
      {
        path: '',
        loadChildren: () => import('./pages/cabinet/cabinet.module').then((m) => m.CabinetModule),
      },
    ]
  : [
      {
        path: '',
        redirectTo: 'gnb',
        pathMatch: 'full',
      },
      {
        path: 'gnb',
        loadChildren: () =>
          import('./pages/global-navigation-bar/global-navigation-bar.module').then((m) => m.GlobalNavigationBarModule),
      },
      {
        path: 'answer',
        loadChildren: () => import('./pages/answer/answer.module').then((m) => m.AnswerModule),
      },
      {
        path: 'error',
        loadChildren: () => import('./pages/error/error.module').then((m) => m.ErrorModule),
      },
      {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'profile',
        loadChildren: () => import('./pages/my/my.module').then((m) => m.MyModule),
        canActivate: [AuthGuard],
      },
      // 사용자 입장에서 너무 긴 url(favour-tournament). --> change to fw(favour-worldcup)
      {
        path: 'fw',
        loadChildren: () =>
          import('./pages/favour-tournament/favour-tournament.module').then((m) => m.FavourTournamentModule),
      },
      {
        path: 'quiz',
        loadChildren: () => import('./pages/quiz/quiz.module').then((m) => m.QuizModule),
      },
      {
        path: 'ideal',
        loadChildren: () => import('./pages/mbti-ideal-type/mbti-ideal-type.module').then((m) => m.MbtiIdealTypeModule),
      },
      {
        path: 'ideal-quiz',
        loadChildren: () => import('./pages/mbti-ideal-type-quiz/quiz.module').then((m) => m.QuizModule),
      },
      {
        path: 'bf',
        loadChildren: () =>
          import('./pages/mbti-best-friend/mbti-best-friend.module').then((m) => m.MbtiBestFriendModule),
      },
      {
        path: 'alarm',
        component: AlarmComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'setting',
        loadChildren: () => import('./pages/setting/setting.module').then((m) => m.SettingModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'chemi',
        loadChildren: () => import('./pages/chemi/chemi.module').then((m) => m.ChemiModule),
      },
      {
        path: 'ask',
        loadChildren: () => import('./pages/ask/ask.module').then((m) => m.AskModule),
      },
      {
        path: 'personality',
        loadChildren: () => import('./pages/personality/personality.module').then((m) => m.PersonalityModule),
      },
      {
        path: 'test',
        redirectTo: 'personality/test',
        pathMatch: 'full',
      },
      {
        path: 'attachment-test',
        loadChildren: () =>
          import('./pages/attachment-type/attachment-type-test.module').then((m) => m.AttachmentTypeTestModule),
      },
      {
        path: 'tc',
        loadChildren: () => import('./pages/thinking-chair/thinking-chair.module').then((m) => m.ThinkingChairModule),
      },
      {
        path: 'signal',
        loadChildren: () => import('./pages/signal/signal.module').then((m) => m.SignalModule),
      },
      {
        path: 'image-game',
        loadChildren: () => import('./pages/image-game/image-game.module').then((m) => m.ImageGameModule),
      },
      {
        path: 'guess-me',
        loadChildren: () => import('./pages/guess-me/guess-me.module').then((m) => m.GuessMeModule),
      },
      {
        path: 'group-chemi',
        loadChildren: () => import('./pages/group-chemi/group-chemi.module').then((m) => m.GroupChemiModule),
      },
      {
        path: 'chat-analysis',
        loadChildren: () => import('./pages/chat-analysis/chat-analysis.module').then((m) => m.ChatAnalysisModule),
      },
      {
        path: 'install',
        component: InstallComponent,
      },
      {
        path: 'friend-distribution/chart',
        component: BubbleChartComponent,
      },
      {
        path: 'cabinet',
        loadChildren: () => import('./pages/cabinet/cabinet.module').then((m) => m.CabinetModule),
      },
      {
        path: 'survey',
        loadChildren: () => import('./pages/survey/survey.module').then((m) => m.SurveyModule),
      },
      {
        path: 'log-quiz',
        loadChildren: () => import('./pages/daily-log-quiz/daily-log-quiz.module').then((m) => m.DailyLogQuizModule),
      },
      {
        path: 'daily-log',
        loadChildren: () => import('./pages/daily-log/daily-log.module').then((m) => m.DailyLogModule),
      },
      {
        path: 'saju',
        loadChildren: () => import('./pages/saju/saju.module').then((m) => m.SajuModule),
      },
      {
        path: 'hsp',
        loadChildren: () => import('./pages/hsp-quiz/hsp-quiz.module').then((m) => m.HspQuizModule),
      },
      {
        path: 'egen-teto',
        loadChildren: () => import('./pages/egen-teto-quiz/egen-teto-quiz.module').then((m) => m.EgenTetoQuizModule),
      },
      {
        path: 'soulmate',
        loadChildren: () => import('./pages/soulmate/soulmate.module').then((m) => m.SoulmateModule),
      },
      {
        path: 'types-story',
        component: TypesStoryComponent,
      },
      {
        path: 'terms/:type',
        component: TermsComponent,
      },
      {
        path: ':uniqueName',
        loadChildren: () => import('./pages/profile/profile.module').then((m) => m.ProfileModule),
        canActivate: [FriendProfileGuard],
      },
      {
        path: 'oauth/kakao/login',
        component: KakaoCallbackComponent,
        canActivate: [KakaoCallbackGuard],
      },
      {
        path: 'oauth/kakao/friend',
        component: KakaoCallbackComponent,
        canActivate: [KakaoCallbackGuard],
      },
      {
        path: 'oauth/kakao/phone',
        component: KakaoCallbackComponent,
        canActivate: [KakaoCallbackGuard],
      },
      {
        path: 'oauth/apple',
        component: AppleCallbackComponent,
        canActivate: [KakaoCallbackGuard],
      },
      {
        path: 'oauth/google',
        component: GoogleCallbackComponent,
        canActivate: [KakaoCallbackGuard],
      },

      { path: '**', redirectTo: 'error', pathMatch: 'full' },
    ]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
